(() => {
  const cartForm = document.querySelector('.cart-form');
  if (!cartForm) return;

  const updateButton = cartForm.querySelector('[data-cart-page-update]');

  const submitUpdate = (line) => {
    line?.classList.add('is-updating');
    if (updateButton && typeof cartForm.requestSubmit === 'function') {
      cartForm.requestSubmit(updateButton);
      return;
    }
    cartForm.submit();
  };

  cartForm.querySelectorAll('[data-cart-page-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('[data-cart-page-quantity-input]');
    const minus = quantity.querySelector('[data-cart-page-quantity-minus]');
    const plus = quantity.querySelector('[data-cart-page-quantity-plus]');
    if (!input || !minus || !plus) return;

    const changeQuantity = (amount) => {
      const currentValue = Number.parseInt(input.value, 10) || 0;
      input.value = Math.max(0, currentValue + amount);
      submitUpdate(quantity.closest('.cart-line'));
    };

    minus.addEventListener('click', () => changeQuantity(-1));
    plus.addEventListener('click', () => changeQuantity(1));
  });
})();
